import _merge from 'lodash/merge'
import taboola from './taboola'
import taboolaDefaults from '../taboolaDefaults'

export default {
  'editionSettings': {
    'key': 'espncricinfo-en-uk',
    'site': 'espncricinfo',
    'language': 'en',
    'country': 'gb',
    'countryName': 'unitedkingdom',
    'domain': 'www.espncricinfo.com',
    'editionSiteId': '1',
    'https': true
  },
  'navId': '18444676',
  'dictionarySection': 'espn',
  'javaLocale': {
    'language': 'en',
    'region': 'GB'
  },
  'dateTime': {
    'long': 'dddd MMMM d, yyyy',
    'medium': 'MMMM d, yyyy',
    'short': 'M/d',
    'timeFormat': 'h:mm',
    'firstDayOfWeek': 'Sunday',
    'timeZone': 'Etc/GMT',
    'defaultFormat': 'd MMM, yyyy',
    'timeZoneString': 'GMT',
    'timeZoneBucket': 'Europe/London',
    'MMM D, YYYY': 'D MMM, YYYY',
    'M/D/YYYY': 'D/M/YYYY',
    'MM/DD/YYYY': 'DD/MM/YYYY',
    'MMDDYYYY': 'DDMMYYYY',
    'MMMM Do YYYY': 'Do MMMM YYYY',
    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
    'M/D': 'D/M',
    'MMMM D, YYYY': 'D MMMM YYYY',
    'dddd, M/D': 'dddd, D/M',
    'age': {
      'seconds': 's',
      'minutes': 'm',
      'hours': 'h',
      'days': 'd'
    }
  },
  'numberFormat': {
    'long': '#,###',
    'short': '###',
    'currency': '#,###.00',
    'percent': '#.00%'
  },
  'temperature': {
    'scale': 'celsius',
    'symbol': '&deg; C'
  },
  'sponsoredContentProviders': [ 'taboola', 'outbrain' ],
  'taboola': _merge({}, taboolaDefaults, taboola),
  'outbrain': {
    'enabled': true,
    'template': 'ESPNIndia',
    'desktop': {
      'compliantId': 'AR_13',
      'nonCompliantId': 'AR_16'
    },
    'mobile': {
      'compliantId': 'MB_6',
      'nonCompliantId': 'MB_9'
    },
    'scores': {
      'desktop': {
        'compliantId': 'AR_49'
      },
      'mobile': {
        'compliantId': 'AR_49'
      }
    },
    'game': {
      'desktop': {
        'compliantId': 'AR_48'
      },
      'mobile': {
        'compliantId': 'MB_48'
      }
    },
    'scorecard': {
      'desktop': {
        'compliantId': 'AR_49'
      },
      'mobile': {
        'compliantId': 'AR_49'
      }
    },
    'table': {
      'desktop': {
        'compliantId': 'AR_43'
      },
      'mobile': {
        'compliantId': 'AR_43'
      }
    },
    'report': {
      'desktop': {
        'compliantId': 'AR_30',
        'nonCompliantId': 'AR_16'
      },
      'mobile': {
        'compliantId': 'MB_6',
        'nonCompliantId': 'MB_9'
      }
    },
    'statistics': {
      'desktop': {
        'compliantId': 'AR_49',
        'nonCompliantId': 'AR_16'
      },
      'mobile': {
        'compliantId': 'MB_6',
        'nonCompliantId': 'MB_9'
      }
    },
    'schedule': {
      'desktop': {
        'compliantId': 'AR_43'
      },
      'mobile': {
        'compliantId': 'AR_43'
      }
    }
  },
  'omniture': {
    'enabled': true
  },
  'chartBeat': {
    'enabled': true
  },
  'ads': {
    'disabled': false,
    'network': 1234,
    'partnerAd': false,
    'dev-config': 15039572,
    'qa-config': 15039572,
    'prod-config': 15039572
  },
  'partnerModules': {
    'global': false,
    'nba': false,
    'womenbb': false,
    'golf': false,
    'endurance': false,
    'horse': false,
    'nascar': false
  },
  'sportBranding': [ {
    'sport': 'cricket',
    'image': 'logo-uk-cricinfo',
    'url': null
  }, {
    'sport': 'soccer',
    'image': 'logo-uk-fc',
    'url': null
  }, {
    'sport': 'rugby',
    'image': 'logo-uk-scrum',
    'url': null
  }, {
    'sport': 'ncaaw',
    'image': 'ESPNcom-powerby-espnw',
    'url': null
  }, {
    'sport': 'ncw',
    'image': 'ESPNcom-powerby-espnw',
    'url': null
  }, {
    'sport': 'wnba',
    'image': 'ESPNcom-powerby-espnw',
    'url': null
  }, {
    'sport': 'womenbb',
    'image': 'ESPNcom-powerby-espnw',
    'url': null
  } ],
  'siteLogo': {
    'class': 'sony-espn',
    'featurePhone': {
      'name': 'sonyespn-logo',
      'width': 62,
      'height': 34
    }
  },
  'meta': {
    'titleBranding': ' - ESPN',
    'description': 'Visit ESPN to get up-to-the-minute sports news coverage, scores, highlights and commentary for cricket, rugby, football, F1, kabaddi and more.',
    'defaultMetaImage': 'sonyespn_black.png',
    'social': {
      'twitter': {
        'twitterId': '',
        'card': 'summary',
        'app_id_iphone': '317469184',
        'site': 'ESPN',
        'app_name_googleplay': 'ESPN',
        'app_id_googleplay': 'com.espn.score_center',
        'app_name_iphone': 'ESPN',
        'language': 'en'
      },
      'facebook': {
        'id': '116656161708917',
        'og_site_name': 'ESPN',
        'locale': 'en_US'
      }
    }
  },
  'shop': {
    'enabled': false
  },
  'sportReplacements': {
    'f1': 'f1',
    'cycling': 'cycling'
  },
  'uriRewrites': {
    'urls': {
      'toEdition': {},
      'toEnglish': {}
    },
    'roots': {
      '/oly/summer/gymnastics/': '/oly/summer/gymnastics/',
      '/oly/summer/cycling/': '/oly/summer/cycling/',
      '/college-football/': '/ncf/',
      '/football/': '/soccer/',
      '/racing/nascar/': '/nascar/',
      '/racing/': '/rpm/',
      '/mens-college-basketball/': '/ncb/',
      '/womens-college-basketball/': '/ncw/',
      '/womens-basketball/': '/womenbb/',
      '/olympics/': '/oly/',
      '/cycling/': '/cycling/',
      '/fixtures/': '/schedule',
      '/figure-skating/': '/oly/',
      '/college-sports/': '/ncaa/',
      '/gymnastics/': '/oly/',
      '/skiing/': '/oly/',
      '/horse-racing/': '/horse/',
      '/sports/womenbb/': '/womenbb/',
      '/sports/horse/': '/horse/'
    },
    'pathSegments': {},
    'paramKeys': {},
    'paramValues': {}
  },
  'betting': {
    'enabled': false,
    'provider': 'Bet 365',
    'game': {
      'enabled': false,
      'provider': 'Bet 365'
    }
  },
  'ticketProvider': null,
  'hasTickets': false,
  'showFavorites': true,
  'showInsider': false,
  'showWatch': false,
  'hideCategoryLinks': [
    600,
    1700
  ],
  'categorySettings': {
    'leagues': true,
    'athletes': false,
    'teams': false,
    'tags': true
  },
  'showFCContent': true,
  'showCricInfoContent': true,
  'cookieConsent': false,
  'scDeepLinking': true,
  'allowShortUrl': false,
  'allowPrintUrl': true,
  'allowUserAccountManagement': true,
  'nowFeed': false,
  'searchUrl': 'http://search.espn.com/',
  'hasSearch': true,
  'gameSettings': {
    'topEventsId': 19408137,
    'promotedSoccerLeaguesCeId': 12032789,
    'showBroadcast': false
  },
  'fallback': {
    'rugby': 'espnuk-en-rugby-index',
    'horse': 'espnuk-en-horse-index',
    'nba': 'espn-en-nba-index',
    'mlb': 'espn-en-mlb-index',
    'nfl': 'espn-en-nfl-index',
    'chalk': 'espn-en-chalk-index',
    'nhl': 'espn-en-nhl-index',
    'nascar': 'espn-en-nascar-index',
    'womenbb': 'espn-en-womenbb-index',
    'ncf': 'espn-en-ncf-index',
    'ncb': 'espn-en-ncb-index',
    'boxing': 'espn-en-boxing-index',
    'mma': 'espn-en-mma-index',
    'esports': 'espn-en-esports-index',
    'nba-stephen-curry': 'espn-en-nba-stephen-curry-index',
    'oly-summer-archery': 'espn-en-oly-summer-archery-index',
    'oly-summer-athletics': 'espnuk-en-oly-summer-athletics-index',
    'oly-summer-badminton': 'espn-en-oly-summer-badminton-index',
    'oly-summer-basketball': 'espnuk-en-oly-summer-basketball-index',
    'oly-summer-boxing': 'espnuk-en-oly-summer-boxing-index',
    'oly-summer-canoe': 'espn-en-oly-summer-canoe-index',
    'oly-summer-cycling': 'espn-en-oly-summer-cycling-index',
    'oly-summer-equestrian': 'espn-en-oly-summer-equestrian-index',
    'oly-summer-fencing': 'espn-en-oly-summer-fencing-index',
    'oly-summer-field-hockey': 'espn-en-oly-summer-field-hockey-index',
    'oly-summer-golf': 'espnuk-en-oly-summer-golf-index',
    'oly-summer-gymnastics': 'espnuk-en-oly-summer-gymnastics-index',
    'oly-summer-handball': 'espn-en-oly-summer-handball-index',
    'oly-summer-judo': 'espn-en-oly-summer-judo-index',
    'oly-summer-modern-pentathlon': 'espn-en-oly-summer-modern-pentathlon-index',
    'oly-summer-rowing': 'espn-en-oly-summer-rowing-index',
    'oly-summer-rugby': 'espnuk-en-oly-summer-rugby-index',
    'oly-summer-sailing': 'espn-en-oly-summer-sailing-index',
    'oly-summer-shooting': 'espn-en-oly-summer-shooting-index',
    'oly-summer-soccer': 'espnuk-en-oly-summer-soccer-index',
    'oly-summer-swimming': 'espnuk-en-oly-summer-swimming-index',
    'oly-summer-table-tennis': 'espn-en-oly-summer-table-tennis-index',
    'oly-summer-taekwondo': 'espn-en-oly-summer-taekwondo-index',
    'oly-summer-tennis': 'espnuk-en-oly-summer-tennis-index',
    'oly-summer-triathlon': 'espn-en-oly-summer-triathlon-index',
    'oly-summer-volleyball': 'espnuk-en-oly-summer-volleyball-index',
    'oly-summer-water-polo': 'espn-en-oly-summer-water-polo-index',
    'oly-summer-weightlifting': 'espn-en-oly-summer-weightlifting-index',
    'oly-summer-wrestling': 'espn-en-oly-summer-wrestling-index'
  },
  'editionAlert': {
    'enabled': true,
    'text': 'Welcome to Sony ESPN India Edition'
  },
  'feeds': {
    'googlenews': {
      'allowedContentTypes': [
        'Story',
        'HeadlineNews'
      ]
    }
  },
  'tier2NavIds': {
    'boston': 12375278,
    'chicago': 12505826,
    'cleveland': 13977091,
    'dallas': 12505828,
    'los-angeles': 12505831,
    'milwaukee': 13977360,
    'new-york': 12505854,
    'fantasy/basketball': 12405600,
    'fantasy/football': 12405632,
    'fantasy/baseball': 12405631,
    'fantasy/hockey': 12405634,
    'fantasy': 13609307,
    'ncfrecruiting': 11588758,
    'ncbrecruiting': 11588880,
    'esports': 13663224,
    'onenacion': 13309315,
    'nba/stephen-curry': 14950765,
    'league': {
      'soccer': 13794648,
      'ncf': 13886385,
      'college-football': 13886385,
      'cricket': 15609108
    }
  },
  'tier3NavIds': {
    'clubhouse': {
      'nba': 12293424,
      'mlb': 12343023,
      'mens-college-basketball': 13884705,
      'womens-college-basketball': 13930164,
      'soccer': 12294454,
      'nfl': 12509708,
      'college-football': 13345157,
      'cricket': 15368856
    }
  },
  'indexAutoStart': false,
  'useMongo': true,
  'activeSite': true,
  'countries': [ {
    'name': 'India',
    'country-code': 'in',
    'showHreflang': true
  }, {
    'name': 'Bangladesh',
    'country-code': 'bd',
    'showHreflang': false
  }, {
    'name': 'Bhutan',
    'country-code': 'bt',
    'showHreflang': false
  }, {
    'name': 'Maldives',
    'country-code': 'mv',
    'showHreflang': false
  }, {
    'name': 'Nepal',
    'country-code': 'np',
    'showHreflang': false
  }, {
    'name': 'Pakistan',
    'country-code': 'pk',
    'showHreflang': false
  }, {
    'name': 'Sri Lanka',
    'country-code': 'lk',
    'showHreflang': false
  } ]
}



// WEBPACK FOOTER //
// ../app/lib/utils/editions/config/cricinfo/unitedkingdom.js